import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from '@/pages/home/components/Hero';
import SectionsPart1 from '@/pages/home/components/SectionsPart1';
import SectionsPart2 from '@/pages/home/components/SectionsPart2';
import SectionsPart3 from '@/pages/home/components/SectionsPart3';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <SectionsPart1 />
        <SectionsPart2 />
        <SectionsPart3 />
      </main>
      <Footer />
    </div>
  );
}